export default __webpack_public_path__ + "static/media/icon-sustainability-none.df965c57.svg";